import { type TokenDO } from "../../tokenData/models/tokenDO.models"

export const assetScreenerColumns = [
    'name',
    'price',
    'percent_change_24h',
    'percent_change_7d',
    'percent_change_30d',
    'market_cap',
    'volume_24h',
    'fully_diluted_market_cap'
]

export interface Sort {
    field: string
    direction: 'asc' | 'desc'
}

export interface WebflowToken {
    slug: string
    icon: string
    path?: string
}

export const COMPARISON_OPTIONS: Record<string, (a: TokenDO, b: TokenDO, direction: 'asc' | 'desc', field?: string) => number> = {
    // String comparison for text fields
    string: (a: TokenDO, b: TokenDO, direction: 'asc' | 'desc') => {
        const aValue = a.name.toLowerCase()
        const bValue = b.name.toLowerCase()
        return direction === 'desc' 
            ? bValue.localeCompare(aValue)
            : aValue.localeCompare(bValue)
    },
    // Numeric comparison for data fields
    numeric: (a: TokenDO, b: TokenDO, direction: 'asc' | 'desc', field: string) => {
        const aValue = a.data[field]
        const bValue = b.data[field]
        return direction === 'desc' 
            ? bValue - aValue
            : aValue - bValue
    }
}
